import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RangePicker from '../../../trends/RangePicker';
import BaseFilterPopover from './BaseFilterPopover';

export class TimeRangeOptions {
  constructor(min, max) {
    this.min = min;
    this.max = max;
  }
}

TimeRangeOptions.propTypes = {
  min: PropTypes.float,
  max: PropTypes.float,
};

const TimeRangeFilterPopover = ({ label, onApplyFilter, options }) => {
  const { min, max } = options;
  const [value, setValue] = useState([min, max]);

  return (
    <BaseFilterPopover label={label} onApplyFilter={onApplyFilter} value={value}>
      <span style={{ height: '300px', display: 'inline-block' }}>
        <RangePicker
          from={min}
          to={max}
          onChange={setValue}
          timezone={Intl.DateTimeFormat().resolvedOptions().timeZone}
        />
      </span>
    </BaseFilterPopover>
  );
};

export default TimeRangeFilterPopover;
